// Casa Elio - mock data extracted from casa-elio.lovable.app

export const SITE = {
  name: "Casa Elio",
  tagline: "Boutique Villa · San Juan del Sur, Nicaragua",
  whatsapp: "+50577698277",
  whatsappRaw: "50577698277",
  email: "FXTattoo@yahoo.com",
  bookingUrl: "https://www.booking.com/hotel/ni/casa-elio-bed-and-breakfast.html",
  airbnbUrl: "https://www.airbnb.com/rooms/1630092744966844967",
};

export const HERO_IMAGE =
  "https://cf.bstatic.com/xdata/images/hotel/max1920x1080/843224454.jpg?k=894ff71907381a3559eb93430569bc12e3557bd0a1d0460422834df363ba523d&o=";

// Single palm tree asset used strategically across the site
export const PALMS = {
  pair:   "https://customer-assets.emergentagent.com/job_casa-elio-sjds/artifacts/tczwo2ka_image.png",
  // Aliases so existing code paths keep working with the same image
  single: "https://customer-assets.emergentagent.com/job_casa-elio-sjds/artifacts/tczwo2ka_image.png",
  row:    "https://customer-assets.emergentagent.com/job_casa-elio-sjds/artifacts/tczwo2ka_image.png",
  // Sage-green sketch palm — used for the small scattered background motif
  sketch: "https://customer-assets.emergentagent.com/job_casa-elio-sjds/artifacts/doftslc9_image.png",
};

export const HERO_SLIDES = [
  {
    src: "https://cf.bstatic.com/xdata/images/hotel/max3000x2000/843224454.jpg?k=894ff71907381a3559eb93430569bc12e3557bd0a1d0460422834df363ba523d&o=",
    caption: "Villa with pool at sunset",
  },
  {
    src: "https://cf.bstatic.com/xdata/images/hotel/max3000x2000/843760980.jpg?k=17eea8168d0eae204fe51f1a04f0b4ac471e3e8d679f1c14b8a90e0d55c04931&o=",
    caption: "Infinity pool overlooking the Pacific",
  },
  {
    src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/eb1f8e89-2546-41a1-ac6f-707857db0b9c.jpeg?im_w=2560",
    caption: "Open-air villa exterior",
  },
  {
    src: "https://cf.bstatic.com/xdata/images/hotel/max3000x2000/843224480.jpg?k=5dc2f548df086ca0decac3c755e9d22b98cf87ce88980155840c9e02ea8f693b&o=",
    caption: "Pool terrace at golden hour",
  },
  {
    src: "https://cf.bstatic.com/xdata/images/hotel/max3000x2000/843761166.jpg?k=3ea243deb4d6c8337186a9f93b4e6748299d7fe59000d0d2f80233f392ee79b9&o=",
    caption: "Suite with ocean view",
  },
  {
    src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/2feecbab-48b5-46a4-b2e1-a4cc6eb199bd.jpeg?im_w=2560",
    caption: "Open-air exterior at dusk",
  },
];


export const POOL_IMAGE =
  "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843760980.jpg?k=17eea8168d0eae204fe51f1a04f0b4ac471e3e8d679f1c14b8a90e0d55c04931&o=";

export const VILLA_EXTERIOR =
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/eb1f8e89-2546-41a1-ac6f-707857db0b9c.jpeg?im_w=1440";

export const POOL_TERRACE =
  "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843224480.jpg?k=5dc2f548df086ca0decac3c755e9d22b98cf87ce88980155840c9e02ea8f693b&o=";

export const SUITE_HERO =
  "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843761166.jpg?k=3ea243deb4d6c8337186a9f93b4e6748299d7fe59000d0d2f80233f392ee79b9&o=";

export const SUITES = [
  {
    id: "pacifico",
    number: "01",
    name: "Suite Pacífico",
    label: "Sea View",
    bed: "1 King Bed",
    bathroom: "Ensuite",
    climate: "Air-conditioned",
    access: "Pool & terrace",
    description:
      "The corner suite. Wide sliding doors open to the terrace and the unbroken line of the Pacific.",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/67a22993-f2a2-4cd4-a241-e8920bdca012.jpeg?im_w=1440",
  },
  {
    id: "mirador",
    number: "02",
    name: "Suite Mirador",
    label: "Mountain & Garden",
    bed: "1 King Bed",
    bathroom: "Ensuite",
    climate: "Air-conditioned",
    access: "Pool & terrace",
    description:
      "A quiet room facing the green hillside, full of soft afternoon light and the sound of the breeze.",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/3cc5ff69-2c3d-47b0-aeed-39c0e44e151e.jpeg?im_w=1440",
  },
  {
    id: "horizonte",
    number: "03",
    name: "Suite Horizonte",
    label: "Sea View",
    bed: "1 King Bed",
    bathroom: "Ensuite",
    climate: "Air-conditioned",
    access: "Pool & terrace",
    description:
      "Linen, wood, stone — and the long horizon. The most photographed sunrises in the house.",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/5737b022-ef4f-465c-86fa-adeb311b834a.jpeg?im_w=1440",
  },
];

export const FEATURES = [
  { label: "5 Suites" },
  { label: "Infinity Pool" },
  { label: "Ocean Views" },
  { label: "Pet-Friendly" },
];

export const STATS = [
  { value: 5, suffix: "", label: "Suites" },
  { value: 5, suffix: "", label: "King Beds" },
  { value: 1, suffix: " km", label: "To the Beach" },
  { value: 9.5, suffix: "/10", label: "Guest Rating", decimals: 1 },
];

export const ACTIVITIES = [
  {
    id: "surfing",
    number: "01",
    title: "Surfing",
    tag: "Year-round swell",
    image:
      "https://images.unsplash.com/photo-1501950084492-95ac4e239234?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxzdXJmaW5nJTIwdHJvcGljYWwlMjBiZWFjaHxlbnwwfHx8fDE3Nzc5NTEwMzV8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Some of Central America's most consistent waves break a short drive away. Maderas for the longboard mornings, Playa Hermosa for the long, peeling rights, and Remanso for the after-school crowd. Boards, instructors and reef-safe everything can be arranged from the villa.",
    duration: "Half day",
    level: "All levels",
  },
  {
    id: "zip-line",
    number: "02",
    title: "Zip-line canopy",
    tag: "Above the treetops",
    image:
      "https://images.unsplash.com/photo-1554481924-0eecea3f21de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx6aXAlMjBsaW5pbmclMjBqdW5nbGV8ZW58MHx8fHwxNzc3OTUxMDM1fDA&ixlib=rb-4.1.0&q=85",
    description:
      "Da Flying Frog runs a 17-line canopy course over the dry tropical forest just north of town — long stretches above the canopy, with views all the way down to the bay. A fun half-morning that ends with a cold drink.",
    duration: "3 hours",
    level: "Easy",
  },
  {
    id: "sunset-sail",
    number: "03",
    title: "Sunset sail",
    tag: "Catamaran charter",
    image:
      "https://images.unsplash.com/photo-1761056075029-8003e57ca7f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxjYXRhbWFyYW4lMjB0cm9waWNhbCUyMHdhdGVyfGVufDB8fHx8MTc3Nzk1MTQxNnww&ixlib=rb-4.1.0&q=85",
    description:
      "Sail out of San Juan del Sur Bay aboard a private catamaran for the back half of the afternoon. Snorkel a hidden cove, swim off the boat, and turn for home as the sun folds into the Pacific.",
    duration: "4 hours",
    level: "All levels",
  },
  {
    id: "fishing",
    number: "04",
    title: "Sport fishing",
    tag: "Marlin, tuna, dorado",
    image:
      "https://images.unsplash.com/photo-1625183656263-171183307b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxkZWVwJTIwc2VhJTIwZmlzaGluZ3xlbnwwfHx8fDE3Nzc5NTEwNDd8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Head offshore at first light with a local captain on a fully rigged sport boat. Sailfish, marlin, mahi and yellowfin all run these waters depending on the season. We'll cook the catch back at the villa if you'd like.",
    duration: "Full day",
    level: "Beginner-friendly",
  },
  {
    id: "cristo",
    number: "05",
    title: "Christ of the Mercy",
    tag: "Bay overlook",
    image:
      "https://images.unsplash.com/photo-1713430116914-c132a8169827?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxTYW4lMjBKdWFuJTIwZGVsJTIwU3VyJTIwTmljYXJhZ3VhJTIwQ2hyaXN0fGVufDB8fHx8MTc3Nzk1MTQwOXww&ixlib=rb-4.1.0&q=85",
    description:
      "Drive (or hike) up to Cristo de la Misericordia — the giant white statue that watches over the bay. The 360° view at the top is the best look at San Juan del Sur you'll find: the harbor, the headlands, and the long ribbon of the coast.",
    duration: "1–2 hours",
    level: "Easy",
  },
  {
    id: "horseback",
    number: "06",
    title: "Horseback on the beach",
    tag: "Sunset ride",
    image:
      "https://images.unsplash.com/photo-1777232913479-76202311b16f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxob3JzZWJhY2slMjByaWRpbmclMjBiZWFjaHxlbnwwfHx8fDE3Nzc5NTEwMzV8MA&ixlib=rb-4.1.0&q=85",
    description:
      "A slow ride along an empty stretch of coast with the local horsemen — best timed for the last hour of light, when the surf turns gold and the headlands go to silhouette.",
    duration: "2 hours",
    level: "All levels",
  },
];


export const EXPERIENCE_BLOCKS = [
  {
    title: "Surf culture",
    body:
      "Some of Central America's most consistent waves break minutes away. Maderas, Playa Hermosa, and Remanso are within a short drive — boards, instructors, and reef-safe everything.",
  },
  {
    title: "Wellness & quiet",
    body:
      "Yoga mats and weights at the villa, an at-home gym, and the salt-water infinity pool for slow afternoons. Massages and breathwork can be arranged on the terrace.",
  },
  {
    title: "The table",
    body:
      "Breakfast in-room each morning — fresh fruit, eggs, and choices that travel: American, vegetarian, vegan, Asian. Local recommendations for dinner along the bay.",
  },
  {
    title: "Around the bay",
    body:
      "Sunset boat trips, the Christ of the Mercy lookout, the Sunday markets in town, and a coastline of empty beaches a short drive in any direction.",
  },
];

export const GALLERY = [
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1920x1080/843224454.jpg?k=894ff71907381a3559eb93430569bc12e3557bd0a1d0460422834df363ba523d&o=", caption: "Villa with pool at sunset", category: "Exterior" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/2feecbab-48b5-46a4-b2e1-a4cc6eb199bd.jpeg?im_w=1440", caption: "Open-air villa exterior", category: "Exterior" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/eb1f8e89-2546-41a1-ac6f-707857db0b9c.jpeg?im_w=1440", caption: "Casa Elio facade", category: "Exterior" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843760980.jpg?k=17eea8168d0eae204fe51f1a04f0b4ac471e3e8d679f1c14b8a90e0d55c04931&o=", caption: "Infinity pool with ocean view", category: "Exterior" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843224480.jpg?k=5dc2f548df086ca0decac3c755e9d22b98cf87ce88980155840c9e02ea8f693b&o=", caption: "Poolside terrace", category: "Lifestyle" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843761166.jpg?k=3ea243deb4d6c8337186a9f93b4e6748299d7fe59000d0d2f80233f392ee79b9&o=", caption: "Bedroom with ocean view", category: "Interiors" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/67a22993-f2a2-4cd4-a241-e8920bdca012.jpeg?im_w=1440", caption: "King bedroom", category: "Interiors" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/3cc5ff69-2c3d-47b0-aeed-39c0e44e151e.jpeg?im_w=1440", caption: "Second suite", category: "Interiors" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/5737b022-ef4f-465c-86fa-adeb311b834a.jpeg?im_w=1440", caption: "Third suite", category: "Interiors" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843224433.jpg?k=9d6bfaf99feb9babefe37818a0c5fa1ff8f96c022a069c5eb53e01b753c79074&o=", caption: "Suite with large window", category: "Interiors" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843224577.jpg?k=962e3901f35479a700b6101659ef86771c8309d30c99a2e473a30c1802e37928&o=", caption: "Bathroom detail", category: "Details" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843224560.jpg?k=486f15ee841ef00027ded1cfed95a4d24e92486aaf21a535cbda69bc363eff0f&o=", caption: "Shared kitchen", category: "Interiors" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/c29d177f-7a3b-47c7-a999-d1da60f0d1d3.jpeg?im_w=1440", caption: "Architectural detail", category: "Details" },
  { src: "https://a0.muscache.com/im/pictures/hosting/Hosting-1602521201060632503/original/07284b21-eaaa-4a21-83bb-c7601b079370.jpeg?im_w=1440", caption: "Interior detail", category: "Details" },
  { src: "https://cf.bstatic.com/xdata/images/hotel/max1280x900/843224521.jpg?k=b87b45c0c7a60990f681153298fa12ad85d36e87a538ff60bf68aa3f0517997f&o=", caption: "At-home gym", category: "Lifestyle" },
];

export const REVIEW = {
  rating: "9.5 / 10",
  source: "Booking.com",
  quote:
    "Exceptional in every detail — the design is calm, the views are extraordinary, and the hospitality made it feel like a private home.",
  author: "Verified guest",
};
